// Dependencies
import Hammer from 'hammerjs';


class Slider {
  /**
   * Constructor: Slider Constructor.
   */
  constructor(args = {}) {
    // Elements
    this._root    = args.root;
    this._nodes   = args.nodes;
    this._buttons = args.buttons;

    // Attributes
    this._prev    = null;
    this._current = null;
    
    this._index     = 0;
    this._loop      = true;
    this._running   = false;
    this._length    = this._nodes.length;
    
    this._min = 0;
    this._max = this._length - 1;

    // Hammer
    this.Hammer = new Hammer(this._root);

    // Events
    const { prev, next } = this._buttons;

    if (prev && next) {
      this.prev = this.prev.bind(this);
      this.next = this.next.bind(this);

      prev.addEventListener('click', this.prev);
      next.addEventListener('click', this.next);
    }

    if (this._length >= 1 && window.innerWidth <= 1024) {
      this.Hammer.on('swiperight', this.prev);
      this.Hammer.on('swipeleft' , this.next);
    }
  }


  /**
   * CLamp: Clamp a value between a min and a max.
   * 
   * @param  {Int}  value - Value to clamp.
   * @param  {Int}  min   - Minimum value.
   * @param  {Int}  max   - Maximum value.
   * @param  {Bool} loop  - Loop between values.
   * @return {Int}  Minimun < Value < Maximum.
   */
  static clamp(value, min, max, loop = true) {
    if (loop) {
      if (value < min) {
        value = max;
      }

      if (value > max) {
        value = min;
      }
    }

    return Math.max(min, Math.min(value, max));
  }


  /**
   * Next: Deactivate current node and activate next one.
   */
  next() {
    if (!this._running) {
      // Increase the index and clamp it to [0, length - 1].
      const value = this._index + 1;
      const index = Slider.clamp(value, this._min, this._max, this._loop);

      // Go to next node.
      if ( index !== this._index) {
        this.change(index);
      }
    }
  }


  /**
   * Prev: Deactivate current node and activate next one.
   */
  prev() {
    if (!this._running) {
      // Decrease the index and clamp it to [0, length - 1].
      const value = this._index - 1;
      const index = Slider.clamp(value, this._min, this._max, this._loop);

      // Go to prev node.
      if ( index !== this._index ) {
        this.change(index);
      }
    }
  }


  /**
   * Prev: Deactivate current node and activate next one.
   */
  to(index) {
    if (!this._running) {
      // Clamp index to [0, length - 1].
      index = Slider.clamp(index, this._min, this._max, this._loop);

      // Go to prev node.
      this.change(index, true);
    }
  }


  /**
   * Change: Deactivate current node and activate selected one.
   *
   * @param {Int} index - Selected index.
   */
  change(index, running = true) {
    // Update attributes.
    this._index   = index;
    this._running = running;

    // Update the prev and current nodes.
    this._prev    = this._current;
    this._current = this._nodes[this._index];

    // Toggle previous node and current one.
    if (this._prev) {
      this._prev.classList.remove('is-active');
    }

    if (this._current) {
      this._current.classList.add('is-active');
    }
  }
}

export default Slider;


// WEBPACK FOOTER //
// ./src/js/modules/slider.js